import React from "react";
import Header from "./Header";
import Faq from "./Faq";
import Clients from "./Clients";
import Landing from "./Landing";

function Home() {
	return (
		<>
			<Header />
			<br />
			<Clients />
		</>
	);
}

export default Home;
